import { render, staticRenderFns } from "./MsgElementImage.vue?vue&type=template&id=5891f792"
import script from "./MsgElementImage.vue?vue&type=script&lang=js"
export * from "./MsgElementImage.vue?vue&type=script&lang=js"
import style0 from "./MsgElementImage.vue?vue&type=style&index=0&id=5891f792&prod&lang=less"
import style1 from "./MsgElementImage.vue?vue&type=style&index=1&id=5891f792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports